export default class URLUtils {
  /**
   * URL parser
   * @param { string } [url]  Url string to be parsed
   * @returns { Object }  Url parts as an object
   */
  static parse(url = document.location.toString()) {
    var key = [
      'source',
      'protocol',
      'authority',
      'userInfo',
      'user',
      'password',
      'host',
      'port',
      'relative',
      'path',
      'directory',
      'file',
      'query',
      'hash',
    ];
    var query = { name: 'params', parser: /(?:^|&)([^&=]*)=?([^&]*)/g };
    var parser =
      /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
    var match = parser.exec(url);

    var uri = {};
    var index = key.length;
    while (index--) uri[key[index]] = match[index] || '';

    uri[query.name] = {};
    uri[key[12]].replace(query.parser, function (params, id, value) {
      if (id) uri[query.name][id] = value;
    });

    uri.url = url;

    return uri;
  }

  static setParam(name, value, url = document.location.href) {
    const u = new URL(url);
    u.searchParams.set(name, value);
    return u.toString();
  }

  /**
   * Detect if an url is external or not
   * @param { string } Uri
   * @return { boolean }
   */
  static isExternalURL(url) {
    if (url.substring(0, 4) === 'http' || url.substring(0, 2) === '//') {
      if (URL.parse().host != URL.parse(url).host) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
